import React from "react";
import DelegationContainer from "./DelegationContainer";

const DelegationPage = props => <DelegationContainer {...props} />;

export default DelegationPage;



// WEBPACK FOOTER //
// ./components/employee/delegation/DelegationPage.js